/**
 * 什么时候可以**自动**刷新到新版本（红线 #57：牌局中途绝不触发）。
 *
 * ★ 旧判据是「没有在途手牌 + 没被遮牌 + 连接正常 + 不轮到自己」，一刀切地用于所有场景。
 *   可「遮牌」是本地传手机模式的东西，它的初始值是**遮着**，只有进了牌桌才揭开 ——
 *   于是在大厅里判据永远不成立：提示写着「本手结束后更新」，而大厅里根本没有手牌，
 *   新版本一直等不来。另一头，本地牌局没有存档，一手打完就被自动刷新，整局直接没了。
 *
 * 现在按场景分：
 *  - 本地牌局进行中：**从不**自动刷新（没有存档）；用户可以自己点「立即更新」并确认。
 *  - 正在输入（输入框有焦点 / 聊天在打字或有草稿 / 开着面板）：不刷新，免得吞掉输入。
 *  - 大厅：可以刷新。
 *  - 联机牌桌：两手之间、不轮到自己、连接正常时才刷新（断线重连会接上座位）。
 */
import type { ConnectionPhase } from '../store/index.js'

export interface ReloadSnapshot {
  readonly view: 'lobby' | 'table'
  /** 本地传手机模式有牌局（running / ended） */
  readonly localGame: boolean
  /** 没有在途手牌（或这一手已经结算） */
  readonly tableIdle: boolean
  /** 此刻轮到自己 */
  readonly heroToAct: boolean
  readonly connection: ConnectionPhase
  /** 开着某个面板（买分、转账、选座…） */
  readonly sheetOpen: boolean
  /** 有输入框处于焦点 */
  readonly editing: boolean
  /** 聊天正在打字或有没发完的字 */
  readonly talking: boolean
}

export function isSafeToReload(s: ReloadSnapshot): boolean {
  if (s.localGame) return false
  if (s.editing || s.talking || s.sheetOpen) return false
  if (s.view === 'lobby') return true
  return s.tableIdle && !s.heroToAct && (s.connection === 'live' || s.connection === 'idle')
}

/** 通知上怎么说「什么时候会自动更新」 */
export function updateHint(s: Pick<ReloadSnapshot, 'view' | 'localGame' | 'tableIdle'>): string {
  if (s.localGame) return '本地牌局结束后再更新'
  if (s.view === 'lobby' || s.tableIdle) return '马上自动更新'
  return '这手打完自动更新'
}
